// cachadas-animations.js
// Solo utilidades de layout. Se eliminaron los efectos fuera de manual de marca:
// scramble de títulos, text split, tilt 3D con glare, botones magnéticos, wipe de página,
// parallax, canvas de burbujas, scroll horizontal, contadores, barra de progreso y
// las entradas con GSAP (opacity:0 a la espera de ScrollTrigger). Sin GSAP ni Lenis.
(function () {
  'use strict';

  // Hero + marquee = primer pliegue completo (solo escritorio).
  // Descuenta TODO el grupo de cabecera (anuncio + header), no solo el header.
  function measureAndSetHeroH() {
    function set() {
      // En móvil no tocamos nada: el CSS usa 100svh como fallback,
      // estable ante el show/hide de la barra de URL de Safari.
      if (window.innerWidth <= 749) return;

      var group = document.getElementById('header-group');
      var nav = document.querySelector('header-component');
      var headH = group ? group.getBoundingClientRect().height
                : nav ? nav.getBoundingClientRect().height
                : 68;
      var marqueeSection = document.getElementById('shopify-section-marquee_strip')
                        || document.querySelector('.shopify-section:has(marquee-component)');
      var marqueeH = marqueeSection ? marqueeSection.getBoundingClientRect().height : 0;
      var heroH = window.innerHeight - headH - marqueeH;
      document.documentElement.style.setProperty('--cc-hero-h', Math.max(heroH, 280) + 'px');
    }
    set();
    window.addEventListener('resize', set, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', measureAndSetHeroH);
  } else {
    measureAndSetHeroH();
  }
})();
